import React from "react";
import { useRouter } from "next/router";
import { usePlans } from "@/hooks/usePlans";
import Skeleton from "@mui/material/Skeleton";
import { processString } from '@/utils/processString';
import { useAccessibility } from "@/hooks/useAccessibility";
import { SnackbarInterplan } from "@/components/global/Errors/Snackbar";
import { useFilterClassification } from "@/hooks/useClassification";
import { useFloatingFilterButton } from "@/services/zustand/flotingFilterButton";
import { Container, Title, Button, GradientContainer, WrapperResults, StatusWrapper } from "./styles";
import { Api } from "@/services/configs/axios";
import { array } from "yup";

export const Cards: React.FC = () => {
  const router = useRouter();
  const { fontSizeIncreased } = useAccessibility();
  const { filterError, setFilterError } = useFilterClassification();
  const isOpenFloatFilterButton = useFloatingFilterButton(
    (state) => state.open
  );
  const { plans, isLoading, getAllError, setGetAllError, setPlans } = usePlans();

  const handleNavigate = (id: number) => {
    router.push(`/plano/${id}`);
  };


  // const fetchIcon = async (iconPath: any) => {
  //   try {
  //     const response = await Api.get(`final/download/${iconPath}`); // Exemplo de URL
  //     return response.data; // Supondo que a API retorna a URL completa do ícone
  //   } catch (error) {
  //     console.error("Erro ao buscar ícone:", error);
  //     return null;
  //   }
  // };

  // const rehydratePlans = React.useCallback(async () => {
  //   const updatedPlans = await Promise.all(
  //     plans.map(async (plan) => {
  
  //       if (plan?.arquivosPlano && plan.arquivosPlano?.caminhoIcone) {
  //         const iconUrl = await fetchIcon(plan.arquivosPlano.caminhoIcone);
  //         return {
  //           ...plan,
  //           arquivosPlano: {
  //             ...plan.arquivosPlano,
  //             iconUrl,
  //           },
  //         };
  //       }
  
  //       return plan;
  //     })
  //   );
  
  //   // Utiliza um mapa para otimizar a busca dos planos atualizados
  //   const updatedPlansMap = new Map(updatedPlans.map(plan => [plan.id, plan]));
  
  //   const mergedPlans = plans.map(plan => updatedPlansMap.get(plan.id) || plan);
  
  //   setPlans(mergedPlans);
  // }, []);
  
  // React.useEffect(() => {
  //   rehydratePlans();
  // }, []);

  const skeletonArray = Array.from(
    { length: plans?.length },
    (_, index) => index + 1
  ) as any;

  const ErrorPlans = React.useMemo(() => {
    if (getAllError) {
      return (
        <SnackbarInterplan
          severity="warning"
          open={getAllError}
          title="Falha na busca de planos"
          onClose={() => setGetAllError(false)}
          message="Aconteceu uma falha ao buscar os planos da página."
        />
      );
    }

    return null;
  }, [getAllError, setGetAllError]);

  const ErrorFilter = React.useMemo(() => {
    if (filterError) {
      return (
        <SnackbarInterplan
          severity="warning"
          open={filterError}
          title="Falha na busca dos filtros"
          onClose={() => setFilterError(false)}
          message="Aconteceu uma falha ao efeturar a busca de filtros."
        />
      );
    }

    return null;
  }, [filterError, setFilterError]);

  if (isLoading) {
    return (
      <>
        {skeletonArray.map((item: any) => (
          <GradientContainer openFilterButton={isOpenFloatFilterButton} isLoading={isLoading} isIncrease={fontSizeIncreased} key={item}>
            <Container filterIsOpen={isOpenFloatFilterButton}>
              <Skeleton
                variant="text"
                width={"90%"}
                height={80}
                sx={{ marginTop: "1rem" }}
              />
              <Skeleton variant="rectangular" width={120} height={120} />
              <Skeleton variant="rectangular" width={"90%"} height={26.6} />
              <Skeleton variant="rectangular" width={"90%"} height={26.6} />
              <Skeleton variant="rectangular" width={"90%"} height={26.6} />
              <Skeleton
                variant="rectangular"
                width={"45%"}
                height={41}
                sx={{ borderRadius: "20px", marginBottom: "1rem" }}
              />
            </Container>
          </GradientContainer>
        ))}
      </>
    );
  }

  return (
    <>
      {ErrorPlans}
      {ErrorFilter}
      {plans?.map((item: any) => {
        return (
          <GradientContainer isIncrease={fontSizeIncreased} key={item?.titulo}>
            <Container filterIsOpen={isOpenFloatFilterButton}>
              <StatusWrapper status={item?.status}>
                <div className="status_item">
                  <p>{item?.status === 1 ? 'Vigente' : 'Não vigente'}</p>
                </div>
              </StatusWrapper>
              <Title isIncrease={fontSizeIncreased} len={item?.titulo?.length}>
                <p className="resizeable-accessibility">{item?.titulo}</p>
              </Title>
              {item?.svg && (
                <div>
                  {item?.svg}
                </div>
              )}
              {!item?.svg && (
                <div style={{ marginBottom: '1rem' }} dangerouslySetInnerHTML={{ __html: item?.arquivosPlano?.iconUrl }} />
              )}
              <div className="wrapper_content">
                <p className="resizeable-accessibility content">
                  {processString(item?.descricao)}
                </p>
              </div>
              {item?.hits?.length > 0 && (
                <WrapperResults>
                  <p>Busca: <b>{item?.hits?.length} resultados</b></p>
                </WrapperResults>
              )}
              <Button
                isIncrease={fontSizeIncreased}
                className="resizeable-accessibility"
                onClick={() => handleNavigate(item?.id)}
              >
                <h1>Saiba mais</h1>
              </Button>
            </Container>
          </GradientContainer>
        )
      })}
    </>
  );
};
